<script>
  //// imports

  import ProgressStatus from "lib/components/progressStatus.svelte";
  import { SectionWrapper } from "paxray-components-svelte";
  import Button from "lib/components/Button.svelte";
  
  import {
    DataTable,
    TextInput,
    Modal,
    Toolbar,
    ToolbarContent,
    Loading,
    ToolbarSearch,
    Pagination,
    Checkbox,
  } from "carbon-components-svelte";
  //// temp

  function temp() {
    console.log("Button clicked");
  }

  // shares

  let nameOfCurrentActivity = "Application Name Mapping";

  let filteredRowIdsWindows = [];
  let selectedWindowIds = [];
  let windowpage = 1;
  let partitionLabels = [];
</script>

<SectionWrapper fitScreen={true}>
  <div slot="main" style="width:100%">
    <DataTable
      size="compact"
      rows={partitionLabels}
      sortable
      pageSize={25}
      page={windowpage}
      headers={[
        {
          key: "windowtitle",
          value: "Window Title",
        },
        {
          key: "menu",
          empty: true,
        },
      ]}
    >
      <Toolbar size="sm">
        <ToolbarContent>
          <ToolbarSearch
            shouldFilterRows
            bind:filteredRowIds={filteredRowIdsWindows}
          />
        </ToolbarContent>
      </Toolbar>
    </DataTable>
    <Pagination
      pageSize={25}
      bind:page={windowpage}
      totalItems={filteredRowIdsWindows.length}
      pageSizeInputDisabled
    />
    <Button>Save</Button>
  </div>
</SectionWrapper>

<style>
</style>
